import { Icon } from "components/index";
import {REDIRECT} from "icons"

export function LinkCell({ getValue }) {
    const value = getValue();

    if (!value) return <span>-</span>;

    return (
        <a
            href={value}
            target="_blank"
            rel="noopener noreferrer"
            className="text-zinc-600 "
            onClick={(event) => event.stopPropagation()}
        >
            <Icon icon={REDIRECT} className="size-4"/>
        </a>
    );
}